module.exports = __webpack_public_path__ + "img/timebinder-icon-clock.eabfef9d.svg";